import { Component, OnInit, OnDestroy } from "@angular/core";
import { IState } from "@models/index";
import { IPage } from "@interfaces/index";
import { Observable, Subject } from "rxjs";
import {
  FormControl,
  FormGroup,
  Validators,
  FormBuilder,
} from "@angular/forms";
import {
  PaymentMethodsService,
  UserService,
  HelperService,
  ConfigService,
} from "@services/index";
import { takeUntil } from "rxjs/operators";

@Component({
  selector: 'app-payouts-form',
  templateUrl: './payouts-form.component.html',
  styleUrls: ['./payouts-form.component.scss']
})
export class PayoutsFormComponent implements OnInit {
  paymentMethods$: Observable<IState>;
  payMethods: any = [];

  public payoutForm: FormGroup;

  loadingIndicator: boolean = true;
  selectedRows = [];
  rows: any[] = [];

  page: IPage = {
    total: 0,
    maxPages: 0,
    perPage: 0,
    currentPage: 0,
  };

  paypal: boolean = false;
  bank: boolean = false;

  paymentID;
  userID;
  requisite: any = {};

  profile$: Observable<any>;
  errorObj: any = {};

  treshold$: Observable<any>;
  treshold;

  openBox: number;
  accountData: string;

  private unsubscribe$ = new Subject<void>();
  
  constructor(
    private userService: UserService,
    private paymentMethodsService: PaymentMethodsService,
    private configService: ConfigService,
    private formBuilder: FormBuilder
  ) {

    this.payoutForm = this.formBuilder.group({
      email: new FormControl(null, [Validators.email]),
      full_name: new FormControl(null),
      address: new FormControl(null),
      bank_name: new FormControl(null),
      bank_address: new FormControl(null),
      bank_account_type: new FormControl(null),
      bank_routing: new FormControl(null),
      bank_code: new FormControl(null),
      iban: new FormControl(null),
    });

    this.paymentMethods$ = this.paymentMethodsService.getPaymentMethodsSelector();
    
    this.profile$ = this.userService.getProfileSelector();

    this.treshold$ = this.configService.getconfigsSelector();
    
  }

  ngOnInit() {
    this.paymentMethodsService.fetchPaymentMethods();
    this.configService.fetchTreshold();
    this.profile$.pipe(takeUntil(this.unsubscribe$)).subscribe((profile) => {
      if (HelperService.isObjectEmpty(profile)) return;
      this.paymentID = profile.payment_method_id
        ? profile.payment_method_id
        : "";
      this.userID = profile.userId;

      this.requisite = profile.profile.payment_requisite ? JSON.parse(profile.profile.payment_requisite) : {
        bank_wire_transfer: {},
        paypal: {account_data: ''},
        cheque: {account_data: ''},
        money_bookers: {account_data: ''},
        no_method: {account_data: ''}
      };
      if(this.requisite.bank_account_type) this.requisite = {
        bank_wire_transfer: {},
        paypal: {account_data: ''},
        cheque: {account_data: ''},
        money_bookers: {account_data: ''},
        no_method: {account_data: ''}
      };
      this.payoutForm.patchValue( this.requisite.bank_wire_transfer || {});
    });

    this.treshold$.pipe(takeUntil(this.unsubscribe$)).subscribe((state) => {
      for (const treshold of state.data) {
        this.treshold = treshold.value;
      }
    });

    this.paymentMethods$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((state) => {
        if (state.isLoaded) {
          this.payMethods = state.data;
          if(!this.openBox) this.openBox = this.payMethods.findIndex(x => x.id === this.paymentID)
        }
      });
  }

  checked(id) {
    this.paymentID = id;
  }

  onChangeFormValue(options) {
    this.payoutForm.patchValue({ [options.name]: options.value });
  }

  saveUserPayout() {
    this.errorObj = HelperService.checkValidation(this.payoutForm);
    this.requisite.bank_wire_transfer = {
      full_name: this.payoutForm.value.full_name,
      address: this.payoutForm.value.address,
      bank_name: this.payoutForm.value.bank_name,
      bank_address: this.payoutForm.value.bank_address,
      bank_account_type: this.payoutForm.value.bank_account_type,
      bank_routing: this.payoutForm.value.bank_routing,
      bank_code: this.payoutForm.value.bank_code,
      iban: this.payoutForm.value.iban
    }

    if (HelperService.isObjectEmpty(this.errorObj)) {
      this.paymentMethodsService.updateUserPayout({
        id: this.paymentID,
        requisite: this.requisite,
        userId: this.userID,
      });
    }
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  boxToggle(index){
    this.openBox = this.openBox === index ? null : index;
  }

  setPrimaryMethod(event, id){
    if(event){
      this.paymentID = id;
      this.saveUserPayout()
    }else{
      this.paymentID = null;
    }
  }

  onChangeAccountData(event){
    if(!this.requisite[event.name])this.requisite[event.name] = {}
    this.requisite[event.name]['account_data'] = event.value;
    
  }

}
